var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMedicalPaper = function SvgIconMedicalPaper(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.40001 6.13057H9.80001M3.40001 8.53057H9.80001M3.40001 10.9306H5.00001M11.7312 4.06177L9.4688 1.79937C9.1688 1.49937 8.7616 1.33057 8.3376 1.33057H2.6C1.716 1.33057 1 2.04657 1 2.93057V14.1306C1 15.0146 1.716 15.7306 2.6 15.7306H10.6C11.484 15.7306 12.2 15.0146 12.2 14.1306V5.19297C12.2 4.76897 12.0312 4.36177 11.7312 4.06177ZM7.40001 12.1306C7.40001 11.4682 7.93761 10.9306 8.60001 10.9306C9.26241 10.9306 9.80001 11.4682 9.80001 12.1306C9.80001 12.793 9.26241 13.3306 8.60001 13.3306C7.93761 13.3306 7.40001 12.793 7.40001 12.1306Z",
    stroke: "#FF9700",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMedicalPaper);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-medical-paper.d59761a2ce7ca6522855e5978a9f259c.svg";